import { useModules } from '@entities/common';
import { useMemo } from 'react';
import { useLoadTags } from '@features/common';
import { SectionList } from '@features/events/event-list';
import { doCheckArray } from '@shared/helpers/index.ts';
import { useAppSelector } from '@shared/hooks/index.ts';
import type { Tag } from '@shared/types/common';
import { AsideFilter } from '@shared/ui/aside-filter';
import { CheckboxList } from '@shared/ui/aside-filter/checkbox-list';
import type { AccordionPT } from '@shared/ui/layout/accordion/ui.tsx';
// import { type Author } from '@src/library/models/programs';
import { selectTab } from '@src/library/redux/events/index.ts';

interface Props {
  isOpen: boolean;
  tags: Tag[];
  onTagChange: (tags: number[]) => void;
  selectedTags: number[];
  // authors: Author[];
  selectedAuthors: number[];
  onAuthorChange: (authors: number[]) => void;
  className?: string;
  hasResetButton: boolean;
  handleResetFilter: () => void;
}

export const EventListFilter = ({
  isOpen,
  tags,
  selectedTags,
  onTagChange,
  // authors,
  selectedAuthors,
  onAuthorChange,
  hasResetButton,
  handleResetFilter,
}: Props): JSX.Element => {
  const { selectedModule, eventModules } = useModules();
  useLoadTags(selectedModule?.code ?? 'events');
  const tab = useAppSelector(selectTab);
  const updateSelectionList = (
    currentList: number[],
    updateFunction: (updatedList: number[]) => void,
    id: number
  ): void => {
    const updatedList = currentList.includes(id)
      ? currentList.filter((item) => item !== id)
      : [...currentList, id];
    updateFunction(updatedList);
  };

  const handleTagClick = (id: number): void => {
    updateSelectionList(selectedTags, onTagChange, id);
  };

  const handleAuthorClick = (id: number): void => {
    updateSelectionList(selectedAuthors, onAuthorChange, id);
  };

  const sectionList = useMemo(() => {
    const output = [
      {
        title: 'РАЗДЕЛЫ',
        children: <SectionList />,
        isAlwaysOpen: true,
      },
    ] as AccordionPT[];

    doCheckArray(tags) &&
      output.push({
        title: 'ТЕГИ',
        children: (
          <CheckboxList items={tags} onItemClick={handleTagClick} selectedItems={selectedTags} />
        ),
      });

    // doCheckArray(authors) &&
    //   tab.title !== 'Организую' &&
    //   output.push({
    //     title: 'ОРГАНИЗАТОР',
    //     children: (
    //       <AuthorList
    //         authors={authors}
    //         onAuthorClick={handleAuthorClick}
    //         selectedAuthors={selectedAuthors}
    //       />
    //     ),
    //   });
    return output;
  }, [
    tab,
    // authors,
    handleAuthorClick,
    handleTagClick,
    selectedAuthors,
    selectedTags,
    tags,
  ]);

  return (
    <AsideFilter
      onResetFilter={handleResetFilter}
      showResetBtn={hasResetButton}
      isOpen={isOpen}
      sections={sectionList}
    />
  );
};
